import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface NewReleasesProps {
  items: MediaItem[];
}

export default function NewReleases({ items }: NewReleasesProps) {
  return (
    <section className="mx-auto mt-14 w-full px-4 md:px-6">
      <SectionHeading
        title="新片速递"
        subtitle="最近上线的影视资源，第一时间掌握更新动态"
        icon="ri-movie-2-line"
        moreTo="/category/movie"
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6">
        {items.slice(0, 12).map((item) => (
          <MovieCard key={item.id} item={item} showType />
        ))}
      </div>
      <div className="mt-6 flex justify-center lg:hidden">
        <Link
          to="/category/movie"
          className="flex items-center gap-1 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700"
        >
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
    </section>
  );
}